import { TopCalendarMode } from "../enums";

export const CALENDAR_RANGE = {
  weekStartDay: 0,
  weekDays: 6,
  next7DayIncrement: 6,
  last30DaysOffset: 29,
} as const;

export const CALENDAR_ROW = {
  height: 100,
  headerHeight: 100,
} as const;

export const CALENDAR_NAVIGATION_SHIFT = {
  [TopCalendarMode.TODAY]: { amount: 1, unit: "day" },
  [TopCalendarMode.TOMORROW]: { amount: 1, unit: "day" },
  [TopCalendarMode.YESTERDAY]: { amount: 1, unit: "day" },
  [TopCalendarMode.WEEKEND]: { amount: 1, unit: "week" },
  [TopCalendarMode.WEEK]: { amount: 1, unit: "week" },
  [TopCalendarMode.LAST_WEEK]: { amount: 1, unit: "week" },
  [TopCalendarMode.NEXT_7_DAYS]: { amount: 1, unit: "day" },
  [TopCalendarMode.MONTH]: { amount: 1, unit: "month" },
  [TopCalendarMode.LAST_MONTH]: { amount: 1, unit: "month" },
  [TopCalendarMode.LAST_30_DAYS]: {
    amount: CALENDAR_RANGE.last30DaysOffset + 1,
    unit: "day",
  },
  [TopCalendarMode.CUSTOM]: { amount: 1, unit: "day" },
} as const satisfies Record<
  TopCalendarMode,
  { amount: number; unit: "day" | "week" | "month" }
>;

export const INITIAL_CALENDAR_DROPDOWN_VALUE = TopCalendarMode.TODAY;
export const DEFAULT_CALENDAR_ROW_HEIGHT = CALENDAR_ROW.height;
export const DEFAULT_CALENDAR_HEADER_ROW_HEIGHT = CALENDAR_ROW.headerHeight;
